import React from "react";

const estiloCode = {
  fontFamily: "monospace",
  background: "rgba(0,0,0,0.06)",
  padding: "0 4px",
  borderRadius: 4,
};

const PATRONES = [
  { re: /```([\s\S]+?)```/, wrap: (inner, k) => <code key={k} style={estiloCode}>{inner}</code> },
  { re: /\*([^\n]+?)\*/, wrap: (inner, k) => <strong key={k}>{parse(inner, k + "b")}</strong> },
  { re: /_([^\n]+?)_/, wrap: (inner, k) => <em key={k}>{parse(inner, k + "i")}</em> },
  { re: /~([^\n]+?)~/, wrap: (inner, k) => <s key={k}>{parse(inner, k + "s")}</s> },
];

function parse(texto, keyPrefix) {
  if (!texto) return texto;

  let best = null;
  PATRONES.forEach((p) => {
    const m = p.re.exec(texto);
    if (m && (best === null || m.index < best.m.index)) best = { p, m };
  });
  if (!best) return texto;

  const { p, m } = best;
  const before = texto.slice(0, m.index);
  const after = texto.slice(m.index + m[0].length);
  return (
    <React.Fragment key={keyPrefix}>
      {before}
      {p.wrap(m[1], `${keyPrefix}_${m.index}`)}
      {parse(after, `${keyPrefix}_a${m.index}`)}
    </React.Fragment>
  );
}

const TextoWhatsapp = ({ texto, style }) => (
  <span style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", ...style }}>
    {parse(String(texto == null ? "" : texto), "wa")}
  </span>
);

export default TextoWhatsapp;
